const TENANT_METRICS_DEBUG_QUERY_PARAM = 'tenantMetricsDebug';
const TENANT_METRICS_DEBUG_STORAGE_KEY = 'ct_tenant_metrics_debug';

function isTruthyDebugValue(value: string | null): boolean {
  if (value === null) {
    return true;
  }
  return value !== '0' && value.toLowerCase() !== 'false';
}

/**
 * Return whether tenant metrics websocket/runtime debug logs are enabled for
 * the current browser session.
 *
 * Debug mode can be enabled either with `?tenantMetricsDebug=1` in the URL or
 * by setting `localStorage.ct_tenant_metrics_debug = '1'`.
 */
export function isTenantMetricsDebugEnabled(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const params = new URLSearchParams(window.location.search);
  if (params.has(TENANT_METRICS_DEBUG_QUERY_PARAM)) {
    return isTruthyDebugValue(params.get(TENANT_METRICS_DEBUG_QUERY_PARAM));
  }

  const storedValue = window.localStorage.getItem(TENANT_METRICS_DEBUG_STORAGE_KEY);
  if (storedValue === null) {
    return false;
  }
  return isTruthyDebugValue(storedValue);
}

/**
 * Emit browser console logs for tenant metrics runtime flows when debug mode is
 * enabled. The timestamp is embedded in the prefix so production traces can be
 * correlated with Network/WebSocket timelines more easily.
 */
export function logTenantMetricsDebug(scope: string, message: string, data?: unknown): void {
  if (!isTenantMetricsDebugEnabled()) {
    return;
  }

  const prefix = `[TenantMetricsDebug][${new Date().toISOString()}][${scope}] ${message}`;
  if (data !== undefined) {
    console.log(prefix, data);
    return;
  }
  console.log(prefix);
}
